import React from 'react';
import { Shield, AlertTriangle, CheckCircle } from 'lucide-react';
import SubpageLayout from '../components/SubpageLayout';
import { ImageFadeIn } from '../components/animations/ImageFadeIn';
import { ScrollReveal } from '../components/animations/ScrollReveal';
const AboutPage = () => {
  return <SubpageLayout hero={{
    title: 'About Us',
    subtitle: '"Protecting a Nation, Preserving a Generation" - אלד ם לו "Never Again"',
    backgroundImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/p4PKPjC15jshH9Yud3yVVh/thumbs_b_c_a165911dfabd157071204a3a4f95efdf.jpg'
  }} videoSection={<ScrollReveal animation="fade" data-id="element-361">
          <div className="bg-white pt-16 sm:pt-20" data-id="element-362">
            <div className="max-w-5xl mx-auto" data-id="element-363">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-8 tracking-tight text-center" data-id="element-364">
                Our Mission: "Never Again"
              </h2>
              <iframe src="https://player.vimeo.com/video/1102181773?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" className="w-full aspect-video" title="The HAMAS Attack on ISRAEL _ October 7th in 11 Minutes _ Mini Documentary" data-id="element-365"></iframe>
            </div>
          </div>
        </ScrollReveal>} stats={[{
    value: '1,040',
    label: 'major terror attacks thwarted in 2024 alone',
    icon: <AlertTriangle className="w-6 h-6 text-red-500" data-id="element-366" />
  }, {
    value: '50,000',
    label: 'civilians to be trained annually at minimal to no cost',
    icon: <Shield className="w-6 h-6 text-israel-blue" data-id="element-367" />
  }, {
    value: '3',
    label: 'regional training centers planned across Israel',
    icon: <CheckCircle className="w-6 h-6 text-green-500" data-id="element-368" />
  }]} cards={[{
    title: 'Mission',
    content: 'To establish Regional Civilian Training Centers (RCTCs) that deliver uniform, legally grounded, and comprehensive training in emergency preparedness, self-defense, crisis response, emergency medical care, and firearms proficiency to Israeli civilians.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fgT2UYSUqZLvWeymTwzsmW/Screenshot_2025-06-06_at_5.11.03_PM.png'
  }, {
    title: 'Vision',
    content: 'A safer, more resilient Israel where civilians are equipped with the critical, life-saving skills needed to survive and thrive in a volatile environment, strengthening both civilian resilience and the national security posture of the State of Israel.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jop9zBgRujeWdeTtyMQTQf/Screenshot_2025-06-06_at_5.11.07_PM.png'
  }, {
    title: 'Values',
    content: "Commitment to Israel's security, excellence in training, accessibility for all citizens, and the fundamental belief that every Israeli civilian deserves the knowledge and skills to protect themselves, their families, and their communities.",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/e882Nks2FnQySsN6rsKsL9/Screenshot_2025-06-06_at_5.11.22_PM.png'
  }]} ctaTitle="Join Our Mission" ctaDescription="Help us build a safer, more resilient Israel through civilian training and preparedness." ctaButtonText="Support Our Work" ctaButtonLink="/support" data-id="element-360">
      {/* The Challenge Section - Now more flowing and less boxy */}
      <ScrollReveal animation="fade" data-id="element-369">
        <div className="mb-20 max-w-5xl mx-auto px-4 sm:px-6" data-id="element-370">
          <div className="text-center mb-12 pt-16" data-id="element-371">
            <div className="inline-flex items-center justify-center mb-4" data-id="element-372">
              <AlertTriangle className="w-8 h-8 text-red-500 mr-2" data-id="element-373" />
              <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-gray-900 tracking-tight" data-id="element-374">
                The Challenge
              </h2>
            </div>
          </div>
          <div className="space-y-8" data-id="element-375">
            {challenges.map((challenge, index) => <ScrollReveal key={index} animation="slide-up" delay={index * 0.1} data-id="element-376">
                <div className="flex" data-id="element-377">
                  <div className="mr-6 flex-shrink-0" data-id="element-378">
                    <div className="flex items-center justify-center w-10 h-10 rounded-full bg-red-100 text-red-600 font-bold" data-id="element-379">
                      {index + 1}
                    </div>
                  </div>
                  <div data-id="element-380">
                    <p className="text-lg text-gray-700 leading-relaxed" data-id="element-381">
                      {challenge}
                    </p>
                  </div>
                </div>
              </ScrollReveal>)}
          </div>
        </div>
      </ScrollReveal>
      {/* Our Answer Section - More visually impactful */}
      <ScrollReveal animation="slide-up" data-id="element-382">
        <div className="relative mb-20 py-16 px-6 sm:px-12 rounded-xl overflow-hidden max-w-5xl mx-auto" data-id="element-383">
          <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-blue-400 opacity-90" data-id="element-384"></div>
          <div className="absolute inset-0 bg-israel-blue opacity-20" data-id="element-385"></div>
          <div className="relative z-10 text-center" data-id="element-386">
            <div className="inline-flex items-center justify-center mb-6" data-id="element-387">
              <CheckCircle className="w-8 h-8 text-white mr-2" data-id="element-388" />
              <h2 className="text-3xl sm:text-4xl font-bold text-white tracking-tight" data-id="element-389">
                Our Answer: Regional Civilian Training Centers
              </h2>
            </div>
            <p className="text-xl text-white/90 max-w-3xl mx-auto font-light leading-relaxed" data-id="element-390">
              State-of-the-art training centers that deliver standardized,
              legally compliant, and comprehensive instruction in emergency
              preparedness, self-defense, crisis response, emergency medical
              care, and weapons proficiency - free (or at minimal cost) to every
              Israeli civilian who needs it.
            </p>
          </div>
        </div>
      </ScrollReveal>
      {/* Why Civilian Training is Critical - More narrative-focused layout */}
      <ScrollReveal animation="fade" data-id="element-391">
        <div className="mb-16 max-w-5xl mx-auto px-4 sm:px-6" data-id="element-392">
          <div className="text-center mb-12" data-id="element-393">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4 tracking-tight" data-id="element-394">
              Why Civilian Training is Critical
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-395">
              When minutes matter, trained civilians become the first line of
              defense
            </p>
          </div>
          <div className="space-y-16" data-id="element-396">
            <ScrollReveal animation="slide-left" data-id="element-397">
              <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-398">
                <div className="w-full md:w-1/2" data-id="element-399">
                  <ImageFadeIn src="https://uploadthingy.s3.us-west-1.amazonaws.com/w7FdN8XNhc2skPzEsmU19p/6f8066266e5cd7e79134b0347368ea550d252540.jpg" alt="Training participants practicing emergency response techniques in a simulated hazardous environment" className="w-full h-auto rounded-lg shadow-md" data-id="element-400" />
                </div>
                <div className="w-full md:w-1/2" data-id="element-401">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-402">
                    Immediate Self-Defense
                  </h3>
                  <p className="text-lg text-gray-700 mb-4 leading-relaxed" data-id="element-403">
                    Attacks often unfold in seconds. Trained civilians can
                    neutralize or mitigate threats before they escalate,
                    especially in isolated areas where security forces aren't
                    immediately available.
                  </p>
                  <p className="text-lg text-gray-700 leading-relaxed" data-id="element-404">
                    In many cases, attackers target isolated homes, small
                    agricultural communities, and roadways. Civilians must be
                    equipped with the skills to handle weapons safely,
                    effectively, and with discipline.
                  </p>
                </div>
              </div>
            </ScrollReveal>
            <ScrollReveal animation="slide-right" data-id="element-405">
              <div className="flex flex-col md:flex-row-reverse gap-8 items-center" data-id="element-406">
                <div className="w-full md:w-1/2" data-id="element-407">
                  <ImageFadeIn src="https://uploadthingy.s3.us-west-1.amazonaws.com/1EgdiYU7M7Njcq9a8GTZ1T/2_Lebensrettendema%C3%9Fnahmen.jpg" alt="Medical Readiness Training" className="w-full h-auto rounded-lg shadow-md" data-id="element-408" />
                </div>
                <div className="w-full md:w-1/2" data-id="element-409">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-410">
                    Medical Readiness
                  </h3>
                  <p className="text-lg text-gray-700 mb-4 leading-relaxed" data-id="element-411">
                    First aid and trauma care training can save lives when
                    emergency medical services are delayed. Attacks in Judea and
                    Samaria often occur in locations where ambulance response
                    times are lengthy.
                  </p>
                  <p className="text-lg text-gray-700 leading-relaxed" data-id="element-412">
                    Civilians must be capable of treating serious injuries on
                    their own and possess the skills to help stabilize victims
                    until help arrives.
                  </p>
                </div>
              </div>
            </ScrollReveal>
            <ScrollReveal animation="slide-left" data-id="element-413">
              <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-414">
                <div className="w-full md:w-1/2" data-id="element-415">
                  <ImageFadeIn src="https://uploadthingy.s3.us-west-1.amazonaws.com/fgT2UYSUqZLvWeymTwzsmW/Screenshot_2025-06-06_at_5.11.03_PM.png" alt="All-Hazard Response Training" className="w-full h-auto rounded-lg shadow-md" data-id="element-416" />
                </div>
                <div className="w-full md:w-1/2" data-id="element-417">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-418">
                    All-Hazard Response
                  </h3>
                  <p className="text-lg text-gray-700 mb-4 leading-relaxed" data-id="element-419">
                    Responding to hazardous events (natural, technological, and
                    man-made) requires specific skills critical to survival in
                    various scenarios facing the Israeli population.
                  </p>
                  <p className="text-lg text-gray-700 leading-relaxed" data-id="element-420">
                    From chemical-radiological attacks to earthquakes, civilians
                    need comprehensive training to protect themselves and their
                    communities in all types of emergencies.
                  </p>
                </div>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </ScrollReveal>
    </SubpageLayout>;
};
const challenges = ['Israel is facing its greatest national security challenge since its founding in 1948, with an unprecedented seven-front war following the October 7th, 2023 attacks.', 'With active-duty IDF forces deployed and reserves repeatedly mobilized—often leaving their families unprotected—the threat to Israeli civilians has reached a critical level.', 'There is no unified national training curriculum in place to systematically prepare Israeli civilians for the complex and growing threats they face.', 'Existing courses are isolated, inconsistent, and frequently operated for profit rather than national security outcomes.', 'As terrorist organizations increasingly target civilian populations, the lack of standardized training has left communities dangerously exposed and unprepared.'];
export default AboutPage;